import React from 'react';
import Util from 'service/util';
import API from 'service/api';

import PopMessage from 'component/pop-msg/PopMessage';

class SuspensionHistory extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      sHist: null,
      license: props.license
    };
    this.loadHistory = this.loadHistory.bind(this);
    this.removeSuspensionHistory = this.removeSuspensionHistory.bind(this);

    this.loadHistory();
  }

  loadHistory()
  {
    this.setState({ sHist: null });
    API.getSuspHistByLicense(this.state.license).then(resp => {
      if (resp.success)
        this.setState({sHist: resp.msg});
      else
        this.setState({error: '讀取失敗'});
    });
  }

  removeSuspensionHistory(h)
  {
    API.deleteSuspensionHistory(h).then(resp => {
      if (resp.success)
        this.loadHistory();
      else
        PopMessage.show('無法移除紀錄。', '存取失敗', 'danger');
    })
  }

  render()
  {
    if (this.state.sHist)
    {
      if (0 == this.state.sHist.length)
        return <p className="message yellow">沒有暫停或終止服務記錄。</p>
      // successfully loaded
      return (
        <table className="data-table susp-hist-table">
          <colgroup>
            <col width="42px"  id="col-srvhis-btndel"/>
            <col width="42px"  id="col-srvhis-company"/>
            <col width="42px"  id="col-srvhis-suspterm"/>
            <col width="120px" id="col-srvhis-end-date"/>
            <col width="60px"  id="col-srvhis-reason-type"/>
            <col width="auto"  id="col-srvhis-remarks"/>
            <col width="42px"  id="col-srvhis-plan"/>
            <col width="60px"  id="col-srvhis-fee"/>
            <col width="60px"  id="col-srvhis-exfee"/>
            <col width="auto"  id="col-srvhis-worker"/>
            <col width="auto"  id="col-srvhis-create-by"/>
            <col width="auto"  id="col-srvhis-create-dtm"/>
          </colgroup>
          <thead>
            <tr>
              <th className="col-srvhis-btndel">移除</th>
              <th className="col-srvhis-company">公司</th>
              <th className="col-srvhis-suspterm">類型</th>
              <th className="col-srvhis-end-date">服務結束日期</th>
              <th className="col-srvhis-reason-type">原因#</th>
              <th className="col-srvhis-remarks">備註</th>
              <th className="col-srvhis-plan">計劃</th>
              <th className="col-srvhis-fee">月費</th>
              <th className="col-srvhis-exfee">附加費</th>
              <th className="col-srvhis-worker">工人</th>
              <th className="col-srvhis-create-by">修定人</th>
              <th className="col-srvhis-create-date">修改日期</th>
            </tr>
          </thead>
          <tbody>
          { this.state.sHist.map(h =>
            <tr key={new Date(h.end_dtm).valueOf()}>
              <td className="col-srvhis-btndel">
                <button className="btn red small" onClick={e=>this.removeSuspensionHistory(h)}>&times;</button>
              </td>
              <td className="col-srvhis-company">{ Util.getCompanyName(h.company) }</td>
              <td className="col-srvhis-suspterm">{ h.is_terminate ? '終止' : '暫停' }</td>
              <td className="col-srvhis-end-date">{ Util.ShortDate(h.end_dtm) }</td>
              <td className="col-srvhis-reason-type">{ Util.getReasonType(h.reason_id) }</td>
              <td className="col-srvhis-remarks">{ h.remarks }</td>
              <td className="col-srvhis-plan">{ h.srv_plan }</td>
              <td className="col-srvhis-fee">${ Util.nf(h.fee) }</td>
              <td className="col-srvhis-exfee">${ Util.nf(h.extra_fee) }</td>
              <td className="col-srvhis-worker">{ h.worker_name} ({ h.worker})</td>
              <td className="col-srvhis-create-by">{ h.create_by }</td>
              <td className="col-srvhis-create-date" title={ Util.FullDate(h.create_dtm) }>
                { Util.ShortDate(h.create_dtm) }
              </td>
            </tr>
          )}
          </tbody>
        </table>
      );
      } else if (this.state.error) {
        // load failed
        return <div>{ this.state.error }</div>
      } else {
        // loading
        return <div>正在讀取中</div>
      }
  }
}

export default SuspensionHistory;